import styled from "styled-components";

export default styled.h3`
	text-align: center;
	padding: 0.8rem 0.2rem;
	width: ${props => props.width};
	font-size: ${props => props.fontSize};
`;
